export default {
  colorPrimary: '#00d8ff',
  blackPrimary: '#0A0203',
};



// WEBPACK FOOTER //
// ./src/styles/theme.js